export default {
  questions: {
    openConversational: {
      openEndPlaceholder: 'Insira seu texto aqui',
      conversationalPlaceholder: 'Por favor, insira sua resposta aqui',
      conversationClosed: 'Conversa encerrada.',
      conversationalDisclaimer: 'As perguntas de acompanhamento serão geradas por IA com base em suas respostas.'
    },
    openText: {
      openEndPlaceholder: 'Insira seu texto aqui'
    },
    multiText: {
      fieldPlaceholder: 'Resposta {number}',
      instruction: 'Digite pelo menos {count} resposta abaixo, uma por caixa de texto | Digite pelo menos {count} respostas abaixo, uma por caixa de texto',
      instructionWithoutMinimum: 'Digite suas respostas abaixo, uma por caixa de texto',
      minimumEntries: 'Insira pelo menos {count} resposta para continuar. | Insira pelo menos {count} respostas para continuar.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marca {number}',
        minimumEntries: 'Insira pelo menos {count} marca para continuar. | Insira pelo menos {count} marcas para continuar.'
      }
    },
    multiselect: {
      caption: 'Selecione todas as opções aplicáveis'
    },
    rankOrder: {
      enterRankOrder: 'Insira a ordem de classificação',
      placeholder: 'Arraste suas opções aqui para classificá-las',
      clearRank: 'Limpar classificação'
    },
    openNumeric: {
      label: 'Numérico aberto'
    },
    complete: {
      message: 'Obrigado por terminar esta pesquisa.'
    },
    openVideo: {
      warning: 'Grave um vídeo antes de continuar.',
      uploadStatusUploading: 'Aguarde até o processamento do vídeo para continuar...',
      uploadStatusSuccess: 'Envio concluído com sucesso, você pode continuar.',
      uploadStatusError: 'O envio não foi concluído. Tente novamente.'
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Insira um e-mail válido',
      text_invalid_phone: 'Insira um número de telefone válido',
      text_invalid_us_zip: 'Insira um CEP válido dos EUA',
      text_invalid_ca_postal: 'Insira um código postal canadense válido',
      text_invalid_uk_postal: 'Insira um código postal do Reino Unido válido',
      text_invalid_custom: 'Insira um {fieldName} válido',
      text_min_chars: 'Insira pelo menos {min} caracteres',
      text_max_chars: 'Insira no máximo {max} caracteres',
      text_alpha_not_allowed: 'Apenas caracteres numéricos são permitidos',
      text_numeric_not_allowed: 'Apenas caracteres alfabéticos são permitidos'
    },
    external: {
      invalid: 'A resposta a esta pergunta não é válida.',
      required: 'Essa pergunta precisa ser respondida.',
      incomplete: 'Responda a esta pergunta completamente antes de prosseguir.',
      singlechoice_required: 'Selecione uma opção antes de continuar.',
      numeric_required: 'Selecione uma classificação antes de continuar.',
      text_required: 'Insira uma resposta antes de continuar.',
      bigtext_required: 'Insira uma resposta antes de continuar.',
      singlechoiceother_incomplete: 'Insira uma resposta antes de continuar.',
      multiselectother_incomplete: 'Insira uma resposta antes de continuar.',
      numeric_invalid: 'Insira um número válido antes de continuar.',
      radiogrid_required: 'Selecione uma opção por cada linha antes de continuar.',
      rankorder_min: 'Classifique pelo menos {value} itens antes de continuar.',
      rankorder_max: 'Classifique no máximo {value} itens antes de continuar.',
      multiselect_min: 'Selecione pelo menos {value} opções antes de continuar.',
      multiselect_max: 'Selecione no máximo {value} opções antes de continuar.',
      multiselectother_min: 'Selecione pelo menos {value} opções antes de continuar.',
      multiselectother_max: 'Selecione no máximo {value} opções antes de continuar.',
      multiselectgrid_min: 'Selecione pelo menos {value} opções por linha antes de continuar.',
      multiselectgrid_max: 'Selecione no máximo {value} opções por linha antes de continuar.'
    }
  }
}
